<script>
  import PropertyEditor from '../common/PropertyEditor.svelte';
  
  export let question;
  export let updateWorkingQuestion;

  let customProperties;
  
  function getNodeCustomProperties() {
    const nodesHandler = question.dataset?.find(handler => handler[0] === 'nodes');
    const selfPropsHandler = question.dataset?.find(handler => handler[0] === 'selfProps');
    
    const handler = nodesHandler || selfPropsHandler;
    if (!handler || !handler[1]) return [];
    
    const props = handler[1];
    // Both 'type' and 'selector' are reserved - they have their own editors
    const reservedKeys = ['type', 'selector'];
    
    return Object.entries(props)
      .filter(([key]) => !reservedKeys.includes(key))
      .map(([key, value]) => ({ key, value: String(value) }));
  }
  
  function updateNodeCustomProperties(newProperties) {
    const dataset = [...question.dataset];
    const nodesHandlerIndex = dataset.findIndex(handler => handler[0] === 'nodes');
    const selfPropsHandlerIndex = dataset.findIndex(handler => handler[0] === 'selfProps');
    
    const handlerIndex = nodesHandlerIndex !== -1 ? nodesHandlerIndex : selfPropsHandlerIndex;
    
    if (handlerIndex !== -1) {
      const handler = [...dataset[handlerIndex]];
      const existingProps = handler[1] || {};
      
      // Preserve reserved properties
      const newProps = {
        type: existingProps.type,
        selector: existingProps.selector
      };
      
      // Remove undefined reserved props
      if (!newProps.type) delete newProps.type;
      if (!newProps.selector) delete newProps.selector;
      
      // Add custom properties
      newProperties.forEach(prop => {
        if (prop.key && prop.key.trim()) {
          newProps[prop.key] = prop.value;
        }
      });
      
      handler[1] = newProps;
      dataset[handlerIndex] = handler;
      updateWorkingQuestion('dataset', dataset);
    }
  }

  $: question, customProperties = getNodeCustomProperties();
</script>

<div class="field-wrapper">

  <PropertyEditor 
    properties={customProperties}
    reservedKeys={['type', 'selector']}
    keyPlaceholder="Property name"
    valuePlaceholder="Property value"
    title="Custom Node Properties"
    description="Add any custom key-value properties to nodes (e.g., category, priority, status). Type and selector are managed above."
    on:update={(e) => updateNodeCustomProperties(e.detail)}
  />
</div>

<style lang="scss">
  .field-wrapper {
    margin-bottom: 15px;
  }
</style>